export default __webpack_public_path__ + "static/media/36I-102759_-37330_0.f09633f9.jpg";